"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_2 = __importDefault(require("@mdi/react"));
const js_1 = require("@mdi/js");
const react_i18next_1 = require("react-i18next");
function Navbar({ user, userSignOut, notification, languages, noTrans, logo, className, }) {
    var _a;
    const [languageMenu, setLanguageMenu] = react_1.useState(false);
    const dropdownRef = react_1.useRef(null);
    const { i18n } = react_i18next_1.useTranslation();
    const changeLanguage = (lang) => {
        localStorage.setItem("language", lang);
        i18n.changeLanguage(lang);
        setLanguageMenu(false);
    };
    const showMenu = () => {
        const menu = dropdownRef.current;
        menu === null || menu === void 0 ? void 0 : menu.classList.toggle("is-active");
        window.addEventListener("mousedown", (e) => {
            const target = e.target;
            if (!target.classList.contains("navbar-dropdown-el") &&
                !target.classList.contains("navbar-dropdown-trigger"))
                menu === null || menu === void 0 ? void 0 : menu.classList.remove("is-active");
        }, { once: true });
    };
    return (react_1.default.createElement("nav", { className: `navbar px-4 has-background-transparent ${className}`, role: "navigation" },
        react_1.default.createElement("div", { className: "ml-auto navbar-brand is-size-4 has-text-weight-medium is-justify-content-flex-end is-align-items-center" },
            logo && (react_1.default.createElement("figure", { className: "image mr-auto is-hidden-tablet" },
                react_1.default.createElement("img", { src: logo, alt: "", className: "has-height-32" }))),
            react_1.default.createElement("div", { className: "buttons my-auto" },
                notification && (react_1.default.createElement("button", { className: "button navbar-item px-2 mx-3 has-background-transparent has-border-radius" },
                    react_1.default.createElement(react_2.default, { path: js_1.mdiBell, size: 1, className: "has-text-neutral-dark80" }))),
                languages && (react_1.default.createElement("div", { className: "is-relative" },
                    react_1.default.createElement("button", { className: "button navbar-item px-2 mx-3 has-background-transparent has-border-radius", onClick: () => setLanguageMenu(!languageMenu) },
                        react_1.default.createElement("img", { src: (_a = languages.find((lang) => lang.lang === i18n.language)) === null || _a === void 0 ? void 0 : _a.icon, alt: "language" })),
                    languageMenu &&
                        languages
                            .filter((lang) => lang.lang !== i18n.language)
                            .map((el) => (react_1.default.createElement("button", { className: "button navbar-item px-2 mx-3 has-background-transparent has-border-radius is-absolute", onClick: () => changeLanguage(el.lang) },
                            react_1.default.createElement("img", { src: el.lang, alt: "language" })))))),
                react_1.default.createElement("div", { className: "dropdown is-right", onClick: showMenu, ref: dropdownRef },
                    react_1.default.createElement("div", { className: "dropdown-trigger is-flex is-align-items-center" },
                        react_1.default.createElement("button", { className: "button has-background-transparent is-borderless has-text-weight-semibold navbar-dropdown-trigger is-flex is-align-items-center m-0 pt-5-tablet" },
                            user.avatar && (react_1.default.createElement("figure", { className: "image is-48x48 navbar-dropdown-el is-40x40-mobile" },
                                react_1.default.createElement("img", { src: user.avatar, alt: "avatar", className: "is-rounded navbar-dropdown-el is-roundded" }))),
                            react_1.default.createElement("p", { className: `ml-2 is-flex navbar-dropdown-el ${user.avatar ? "is-hidden-mobile" : ""}` },
                                user.name,
                                " ",
                                react_1.default.createElement(react_2.default, { path: js_1.mdiChevronDown, size: 1, className: "navbar-dropdown-el" })))),
                    react_1.default.createElement("div", { className: "dropdown-menu is-clipped py-0 has-border-radius", id: "dropdown-menu" },
                        react_1.default.createElement("div", { className: "dropdown-content navbar-dropdown-el has-border-neutral-dark20 py-0 is-hidden-tablet" },
                            react_1.default.createElement("button", { className: "button is-fullwidth mb-0 navbar-dropdown-el is-white is-justify-content-flex-start" },
                                react_1.default.createElement("p", null, user.name))),
                        react_1.default.createElement("div", { className: "dropdown-content navbar-dropdown-el has-border-neutral-dark20 py-0" },
                            react_1.default.createElement("button", { id: "signOut", className: "button is-fullwidth mb-0 navbar-dropdown-el is-white is-justify-content-flex-start", onClick: () => userSignOut() },
                                react_1.default.createElement(react_2.default, { path: js_1.mdiLogout, size: 1, className: "navbar-dropdown-el" }),
                                react_1.default.createElement("p", { className: "ml-2 navbar-dropdown-el" }, noTrans ? "Sign out" : react_1.default.createElement(react_i18next_1.Trans, { i18nKey: "signOut" }))))))))));
}
exports.default = Navbar;
//# sourceMappingURL=Navbar.js.map